import MediaOverlayIconButton from '@components/MediaOverlayIconButton/MediaOverlayIconButton';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../translation/TranslationContext';
import { useProductGalleryNavButtonsStyles } from './productGalleryNavButtons.styles';

interface ProductGalleryNavButtonsProps {
  className?: string;
  hasBorder?: boolean;
  isPreviousHidden?: boolean;
  isNextHidden?: boolean;
  onPrevious: () => void;
  onNext: () => void;
}

const ProductGalleryNavButtons = ({
  className,
  hasBorder = true,
  isPreviousHidden = false,
  isNextHidden = false,
  onPrevious,
  onNext,
}: ProductGalleryNavButtonsProps) => {
  const { translate } = useTranslation();
  const { classes, cx } = useProductGalleryNavButtonsStyles();

  return (
    <div className={cx(classes.root, className)}>
      <div className={cx(classes.buttonSlot, isPreviousHidden && classes.buttonSlotHidden)}>
        <MediaOverlayIconButton
          icon={ArrowLeft}
          tabIndex={-1}
          className={cx(classes.button, !hasBorder && classes.borderless)}
          ariaLabel={translate(LangEnum.GLOBAL_PREVIOUS)}
          onClick={onPrevious}
        />
      </div>

      <div className={cx(classes.buttonSlot, isNextHidden && classes.buttonSlotHidden)}>
        <MediaOverlayIconButton
          icon={ArrowRight}
          tabIndex={-1}
          className={cx(classes.button, !hasBorder && classes.borderless)}
          ariaLabel={translate(LangEnum.GLOBAL_NEXT)}
          onClick={onNext}
        />
      </div>
    </div>
  );
};

export default ProductGalleryNavButtons;
